import Components from './components';
import '../css/main.scss';

if (Components.length) {
  Components.forEach((component) => component.init());
}
